// @ts-nocheck
/* eslint-disable */
export const tickCircleIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 17"><path fill="currentColor" d="M8 1.852c-3.673 0-6.667 2.993-6.667 6.667S4.327 15.185 8 15.185s6.667-2.993 6.667-6.666S11.673 1.852 8 1.852m3.187 5.133-3.78 3.78a.5.5 0 0 1-.707 0L4.813 8.88a.503.503 0 0 1 0-.707.503.503 0 0 1 .707 0l1.533 1.533L10.48 6.28a.503.503 0 0 1 .707 0 .503.503 0 0 1 0 .706"/></svg>`,
    name: 'tick-circle' as const
};